var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 12,
    fill: "#00A215"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10C11.3431 10 10 11.3431 10 13V25C10 26.6569 11.3431 28 13 28H25C26.6569 28 28 26.6569 28 25V13C28 11.3431 26.6569 10 25 10H13ZM14.0446 25H24.0914C24.8981 25 25.3728 24.094 24.9136 23.4308L22.3177 19.6811C21.9213 19.1085 21.0756 19.1063 20.6762 19.6768L18.7501 22.4284C18.3722 22.9683 17.5845 23.0014 17.1626 22.4952L16.2951 21.4541C15.8865 20.9638 15.1294 20.9765 14.7375 21.4803L13.2553 23.3861C12.7444 24.0429 13.2125 25 14.0446 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImage);
export default __webpack_public_path__ + "static/media/icon_image.b776eb38557368a388ff0edeac68fe92.svg";
export { ForwardRef as ReactComponent };